import { createListenerMiddleware } from "@reduxjs/toolkit";
import { message } from "antd";

import { isAiFulfilled, isAiRejected } from "../apis/aiApi";
import { aiErrorMessage, isGloballyHandledAiError } from "../base/baseApi";

const PROVIDER_LABELS = { gpt: "GPT", gemini: "Gemini" };

// App-wide AI notifications. Pages only handle feature-specific errors
// (see isGloballyHandledAiError) so the same toast never shows twice.
export const aiListener = createListenerMiddleware();

aiListener.startListening({
    matcher: isAiFulfilled,
    effect: ({ payload }) => {
        const { fellBack, provider } = payload?.meta || {};
        if (!fellBack) return;

        const label = PROVIDER_LABELS[provider] || provider;
        message.warning({
            key: "ai-fallback",
            content: `The selected AI model was unavailable, so ${label} was used instead.`,
        });
    },
});

aiListener.startListening({
    matcher: isAiRejected,
    effect: (action) => {
        // Aborted requests (e.g. component unmounted) are not errors for the user.
        if (action.meta?.aborted || action.meta?.condition) return;

        const error = action.payload;
        if (!isGloballyHandledAiError(error)) return;

        message.error({ key: `ai-${error.code}`, content: aiErrorMessage(error) });
    },
});
